import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Group, PostGrupo, EntrenamientoGruposDia } from '../../../../../api/interfaces/groups';
import { Day } from '../../../../../api/interfaces/register';
import { GroupsService } from '../../../../../api/services/groups/groups.service';
import { SharedDataService } from 'src/app/services/sharedData/shared-data.service';
import { SnackbarService } from 'src/app/utils/snackbar/snackbar.service';
import { MobileDetectorService } from 'src/app/services/mobileDetector/mobile-detector.service';
import { Masks } from 'src/app/enums/mask';

/**
 * Form: create a new group.
 */
@Component({
  selector: 'app-groups-new',
  templateUrl: './groups-new.component.html',
  styleUrls: ['./groups-new.component.scss']
})
export class GroupsNewComponent implements OnInit {

  @Output() toggleNewEvent = new EventEmitter<boolean>();

  days: Day[] = [
    {name:"Lunes", selected: false, index: 2, disabled: false},
    {name:"Martes", selected: false, index: 3, disabled: false},
    {name:"Miércoles", selected: false, index: 4, disabled: false},
    {name:"Jueves", selected: false, index: 5, disabled: false},
    {name:"Viernes", selected: false, index: 6, disabled: false},
    {name:"Sábado", selected: false, index: 7, disabled: false},
    {name:"Domingo", selected: false, index: 1, disabled: false},
  ];

  groupForm = new FormGroup({
    hora: new FormControl([Validators.required], Validators.minLength(4)),
    capacidad: new FormControl(20)
  });

  disable: boolean = false;
  isMobile: boolean = false;
  disableSubmit: boolean = true;
  timeMask: string = "";

  constructor(
    private groupsService: GroupsService,
    private snack: SnackbarService,
    private sharedData: SharedDataService,
    private mobileDetectorService: MobileDetectorService
  ) { }

  ngOnInit(): void {
    this.timeMask = Masks.GROUP_HOUR;
    this.changeValid();
    this.isMobile = this.mobileDetectorService.isMobile();
    if(this.isMobile) {
      window.scroll({
        top: 1200,
        left: 100,
        behavior: 'smooth'
      });
    }
  }

  toggleNew() {
    this.toggleNewEvent.emit(false);
  }

  onSubmit() {
    const daysSelected: Day[] = this.days.filter(day => day.selected);
    let horario: string = this.groupForm.value.hora;
    let horarioFinal: string = `${horario.charAt(0)}${horario.charAt(1)}:${horario.charAt(2)}${horario.charAt(3)}`;

    const nombre: string = `${daysSelected[0].name} y ${daysSelected[1].name} ${horarioFinal}`;

    let entrenamientoGruposDia: EntrenamientoGruposDia[] = [];
    daysSelected.forEach(day => {
      const aux: EntrenamientoGruposDia = {
        diaSemana: day.index
      }
      entrenamientoGruposDia.push(aux)
    });

    const { capacidad } = this.groupForm.getRawValue();
    const grupo: PostGrupo = {
      entrenamientoGrupoDescripcion: nombre,
      activo: true,
      horario: horarioFinal,
      capacidad: capacidad,
      entrenamientoGruposDia: entrenamientoGruposDia
    }
    this.groupsService.postGrupo(grupo).subscribe( response => {
      this.sharedData.changeMessage("updateGroups");
      this.snack.snackTranslate('snacks.sucess.groups.post');
      this.toggleNew();
    },
    error => {
      console.error(error);
      this.snack.openSnackBar(error.error.message);
    });
  }

  changeValid() {
    const aux: Day[] = this.days.filter(day => day.selected == true);
    const cantidad: number = aux.length;
    if(cantidad == 2 ) {
      this.disableSubmit = false;
    } else {
      this.disableSubmit = true;
    }
  }

  saveDay(day: Day) {
    const position: number = this.days.findIndex(element => element.index == day.index);
    this.days[position].selected = !day.selected;
    let selected: any = [];
    this.days.forEach(day => {
      if(day.selected) {
        selected.push(day);
      }
    });
    this.changeValid();
  }

}